import React, { useRef, useEffect, useState } from "react";
import Paper from "@mui/material/Paper"
import "../planogram.css";
import { Stack } from "@mui/material";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { store } from "../../store/store";


export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "rgba(32, 38, 43, 0.95)",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgba(32, 38, 43, 0.95)",
    maxWidth: "15rem"
  },
}));



const get_image_url = (image) => {
  return `https://caiproduction002.blob.core.windows.net/ira/audit_images/` + image + `?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D`;
}

const get_thumbnail_url = (thumbnail) => {
  return "https://caiproduction002.blob.core.windows.net/ira/iat/thumbnails/" + thumbnail + "?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D"
}

export default function OriginalImage(props) {
  const canvasRef = useRef(null);
  const dispatch = useDispatch();
  const imgNo = props.imgNo;
  const [open, setOpen] = useState(false);
  const [cursorDim, setCursorDim] = useState([0, 0]);
  const [popoverData, setPopoverData] = useState([]);
  const [popoverPaused, setPopoverPaused] = useState(false);
  const [popoverPausedCoords, setPopoverPausedCoords] = useState([]);
  const [pausedPopoverData, setPausedPopoverData] = useState([]);
  const [cropCoords, setCropCoords] = useState([0, 0, 0, 0]);
  const [pausedCropCoords, setPausedCropCoords] = useState([0, 0, 0, 0]);
  const [popoverLiveDim, setPopoverLiveDim] = useState([0, 0]);



  const handlePopoverPause = () => {
    if (open || popoverPaused) {
      setPopoverPaused(!popoverPaused);
      setPopoverPausedCoords(cursorDim);
      setPausedPopoverData(popoverData);
      setPausedCropCoords(cropCoords);
    }
  }


  const handlePopoverLiveDim = (e) => {
    setPopoverLiveDim(e);
  }

  const filterCheck = (boxesDetails) => {
    // applying default filters...
    let boxes = boxesDetails.filter(row => (row.isShelf === 1) && (row.secCategory && (row.secCategory[0] !== "DISPLAY")));

    // returnig boxes as it is if no option is selected
    return []
  }

  useEffect(() => {

    // applying filters as needed
    let boxes = filterCheck(props.imageDetails.thumbnailsDetails);

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = get_image_url(props.imageDetails.imageName);
    img.onload = () => {

      canvas.width = img.width;
      canvas.height = img.height;

        ctx.drawImage(img, 0, 0);

      ctx.lineWidth = 5;

      let i = 0;
        while (i < boxes.length) {
          // drawing default AI boxes
          let w = boxes[i].xmax - boxes[i].xmin;
          let h = boxes[i].ymax - boxes[i].ymin;
          ctx.strokeStyle = "rgb(0, 255, 179)";
          ctx.strokeRect(boxes[i].xmin, boxes[i].ymin, w, h);
          i++;
        }



      // using cursor position to figure which thumbnail the cursor is currently hovering on,
      // also, opening & closing popup based on match condition
      if (!popoverPaused) {
        canvas.addEventListener('mousemove', (event) => {
          const x = event.offsetX / props.resize;
          const y = event.offsetY / props.resize;

          const screenX = event.clientX;
          const screenY = event.clientY;

          const match = boxes.filter(box => ((x > box.xmin) && (x < box.xmax)) && (y > box.ymin) && (y < box.ymax));

          if (match.length === 1) {
            setCursorDim([screenX, screenY]);
            setOpen(match.length > 0);
            setPopoverData(match[0]);
            if (match.length > 0) {
              setCropCoords([match[0]["xmin"], match[0]["ymin"], match[0]["xmax"], match[0]["ymax"]]);
            }
          } else {
            // selecting the box with the minimum area if matches for a coordinate is > 1
            const areas = match.map(row => {
              return (row.ymax - row.ymin) * (row.xmax - row.xmin);
            })

            const min_area = _.min(areas);
            const min_area_idx = areas.indexOf(min_area);
            setCursorDim([screenX, screenY]);
            setOpen(match.length > 0);
            setPopoverData(match[min_area_idx]);
            if (match.length > 0) {
              setCropCoords([match[min_area_idx]["xmin"], match[min_area_idx]["ymin"], match[min_area_idx]["xmax"], match[min_area_idx]["ymax"]]);
            }
          }
        });
      }

      // closing the popup incase cursor leaves the canvas
      canvas.addEventListener("mouseleave", (event) => {
        if (!popoverPaused) {
          setOpen(false);
        }
      })
    };
  }, [popoverPaused, props]);


  return (
    <div
      className="image-analysis"
    >
      <canvas
        id={props.imgNo}
        onClick={handlePopoverPause}
        ref={canvasRef}
        style={{ width: `${props.dim[0] * props.resize}px`, height: `${props.dim[1] * props.resize}px` }}
      ></canvas>
    </div>
  );
}